<template>
  <pannel class="mt-4" title="POWER">
    <template #icon>
      <svg width="8" height="19" viewBox="0 0 8 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.92187 14.6688H7.42564L3.79077 19C3.07319 17.5493 2.38397 16.1545 1.66191 14.6952H3.36111C3.74452 13.2025 4.11599 11.7541 4.51655 10.1955L0 11.4381C0.690723 7.58602 1.36802 3.80699 2.05054 0H6.02107L3.47972 7.8159L8 6.56244C7.2966 9.30623 6.61706 11.9568 5.92187 14.6688Z"
          fill="#0072BB" />
      </svg>
    </template>

    <div class="mt-4 flex justify-between pb-4">
      <div class="flex w-1/2 flex-col items-start">
        <BatteryStatusWidget :available="status_available" :bms_charging_status="md1_bms_charging_status" :bms_soc="md1_soc" class="mt-4"></BatteryStatusWidget>
        <div class="mt-2 text-3xl font-bold text-primary-black">{{ (md1_soc / 10).toFixed(0) }}<span class="text-lg">%</span></div>
        <div class="mt-2 text-sm text-primary-black">MD1 Battery</div>
        <div class="mt-2 text-sm" v-if="md1_power_battery_current < 0">↑ Charge: {{ -(md1_power_battery_current / 10).toFixed(1) }} A</div>
        <div class="mt-2 text-sm" v-else>↑ Charge: 0 A</div>
        <div class="mt-2 text-sm" v-if="md1_power_battery_current > 0">↓ Discharge: {{ (md1_power_battery_current / 10).toFixed(1) }} A</div>
        <div class="mt-2 text-sm" v-else>↓ Discharge: 0 A</div>
      </div>
      <div class="flex w-1/2 flex-col items-start">
        <BatteryStatusWidget :available="status_available" :bms_charging_status="md2_bms_charging_status" :bms_soc="md2_soc" class="mt-4"></BatteryStatusWidget>
        <div class="mt-2 text-3xl font-bold text-primary-black">{{ (md2_soc / 10).toFixed(0) }}<span class="text-lg">%</span></div>
        <div class="mt-2 text-sm text-primary-black">MD2 Battery</div>
        <div class="mt-2 text-sm" v-if="md2_power_battery_current < 0">↑ Charge: {{ -(md2_power_battery_current / 10).toFixed(1) }} A</div>
        <div class="mt-2 text-sm" v-else>↑ Charge: 0 A</div>
        <div class="mt-2 text-sm" v-if="md2_power_battery_current > 0">↓ Discharge: {{ (md2_power_battery_current / 10).toFixed(1) }} A</div>
        <div class="mt-2 text-sm" v-else>↓ Discharge: 0 A</div>
      </div>
    </div>

    <div class="mt-4 flex justify-between border-t p-4 text-primary-black">
      <svg class="mt-2" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 11.6779C0.22171 6.54669 2.38313 2.70135 6.68167 0.102224C6.97172 -0.0730495 7.1666 -0.0252939 7.33364 0.26378C8.18943 1.74691 9.0432 3.23089 9.89495 4.71572C10.0711 5.02055 10.0195 5.2202 9.7026 5.41072C8.55608 6.09606 7.63077 6.99936 7.00057 8.18461C5.19905 11.5605 6.29191 15.6081 9.5472 17.6341C9.6044 17.6697 9.66261 17.7037 9.7193 17.7408C10.023 17.9379 10.0696 18.1264 9.88786 18.4434C9.26323 19.534 8.6369 20.6234 8.0089 21.7116C7.79022 22.0922 7.57459 22.4737 7.35338 22.8522C7.16862 23.1697 6.97627 23.2215 6.66649 23.0351C3.14798 20.9186 0.969855 17.8572 0.237909 13.7918C0.105288 13.0562 0.0658043 12.3028 0 11.6779Z"
          fill="#0072BB" />
        <path
          d="M17.1649 15.7357C16.1194 16.7897 14.6999 17.3841 13.2181 17.3885C11.7363 17.3929 10.3134 16.8069 9.26177 15.7591C7.08263 13.5984 7.07403 10.0081 9.24203 7.82354C11.4272 5.62424 14.9822 5.6156 17.1664 7.80474C19.3506 9.99388 19.345 13.5359 17.1649 15.7357ZM12.6568 9.51022C12.8065 9.65526 13.0064 9.73656 13.2145 9.73713C13.4226 9.7377 13.6229 9.65749 13.7734 9.51327C13.9207 9.35964 14.0014 9.15371 13.9978 8.94054C13.9942 8.72736 13.9066 8.5243 13.7542 8.37577C13.6806 8.30315 13.5933 8.24603 13.4974 8.20779C13.4016 8.16954 13.299 8.15093 13.1959 8.15306C13.0927 8.15519 12.991 8.17801 12.8968 8.22019C12.8025 8.26237 12.7177 8.32304 12.6471 8.39864C12.5741 8.4717 12.5162 8.55868 12.4771 8.65447C12.4379 8.75026 12.4182 8.85293 12.4191 8.95646C12.42 9.05999 12.4415 9.1623 12.4823 9.25739C12.5231 9.35248 12.5824 9.43844 12.6568 9.51022ZM9.82718 11.2274C9.75425 11.3006 9.69648 11.3875 9.65723 11.4832C9.61797 11.5789 9.59801 11.6815 9.59848 11.785C9.59895 11.8885 9.61985 11.9909 9.65997 12.0862C9.7001 12.1816 9.75865 12.268 9.83224 12.3405C9.98223 12.4849 10.1818 12.566 10.3897 12.5668C10.5975 12.5677 10.7977 12.4883 10.9489 12.3451C11.2577 12.0403 11.2501 11.5205 10.9327 11.2091C10.8597 11.136 10.7728 11.0783 10.6772 11.0395C10.5816 11.0008 10.4792 10.9817 10.3761 10.9834C10.273 10.9851 10.1712 11.0076 10.077 11.0495C9.98266 11.0914 9.89772 11.1519 9.82718 11.2274ZM15.4757 12.338C15.6245 12.4841 15.824 12.5666 16.0322 12.5682C16.2403 12.5697 16.441 12.4901 16.5919 12.3461C16.7401 12.1933 16.822 11.9878 16.8194 11.7745C16.8168 11.5613 16.7301 11.3577 16.5782 11.2086C16.5047 11.1359 16.4176 11.0787 16.3218 11.0401C16.2261 11.0016 16.1237 10.9825 16.0205 10.984C15.9174 10.9855 15.8156 11.0076 15.721 11.0489C15.6264 11.0903 15.541 11.1501 15.4696 11.2249C15.3964 11.298 15.3384 11.385 15.2989 11.4809C15.2595 11.5767 15.2395 11.6795 15.2401 11.7832C15.2406 11.8869 15.2618 11.9894 15.3022 12.0849C15.3427 12.1803 15.4017 12.2667 15.4757 12.339V12.338ZM12.6578 14.0475C12.5837 14.1196 12.5245 14.2056 12.4837 14.3007C12.4428 14.3958 12.4211 14.498 12.4197 14.6015C12.4184 14.705 12.4374 14.8078 12.4757 14.904C12.5141 15.0001 12.5709 15.0877 12.6431 15.1616C12.7932 15.3128 12.9966 15.3984 13.2092 15.3998C13.4218 15.4012 13.6264 15.3184 13.7785 15.1693C13.9215 15.0178 14.0001 14.8163 13.9975 14.6076C13.995 14.399 13.9115 14.1995 13.7648 14.0516C13.6929 13.9774 13.607 13.9183 13.512 13.8779C13.4171 13.8375 13.3151 13.8165 13.2119 13.8162C13.1088 13.8159 13.0067 13.8363 12.9115 13.8762C12.8163 13.9161 12.7301 13.9747 12.6578 14.0485V14.0475Z"
          fill="#0072BB" />
        <path
          d="M10.2958 3.03089L9.50614 1.65918C12.2826 0.459704 17.2574 0.499839 20.8574 4.15518C24.629 7.98426 25.0587 13.8801 21.8591 18.2197C18.6428 22.5797 13.2271 23.4525 9.30569 21.8395L10.0776 20.4947C14.6708 21.7059 18.4363 20.5846 21.0457 16.5183C23.0542 13.3867 22.7936 9.34784 20.6018 6.32247C18.7238 3.72944 14.9107 1.61448 10.2958 3.03089Z"
          fill="#0072BB" />
      </svg>
      <div class="flex flex-col">
        <div class="text-3xl font-bold">{{ drive_brake_level }}<span class="text-base">%</span></div>
        <div class="mt-1 text-sm">Brake Traction<br />Percentage</div>
      </div>
      <div class="flex flex-col">
        <div class="text-3xl font-bold">{{ renewable_energy }}<span class="text-base">kWh</span></div>
        <div class="mt-1 text-sm">Regenerative<br />Braking Energy</div>
      </div>
    </div>

    <div class="mt-4 flex justify-between border-t p-4 text-primary-black">
      <svg class="mt-2" width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.64747 13.5729C3.30844 13.6168 0.0567112 11.0096 0.0626301 7.1507C0.0685491 3.4214 3.13901 0.734252 6.66745 0.740734C10.1959 0.747216 13.2626 3.44588 13.2523 7.17158C13.2412 11.0917 9.92805 13.6327 6.64747 13.5729ZM7.7151 6.7589C7.7151 5.80749 7.72028 4.89857 7.7151 3.98893C7.70992 3.38466 7.23122 2.91868 6.64673 2.92949C6.36636 2.93554 6.0999 3.04954 5.90574 3.24651C5.71158 3.44348 5.60555 3.70735 5.61091 3.98028C5.60425 5.03325 5.61091 6.08693 5.60648 7.14061C5.60286 7.27858 5.628 7.41583 5.68039 7.54408C5.73278 7.67232 5.81134 7.78889 5.9113 7.88676C6.3932 8.36691 6.88004 8.84129 7.3718 9.30992C7.68329 9.60881 8.0695 9.66571 8.46607 9.54615C8.87892 9.42155 9.10753 9.10898 9.16968 8.69989C9.22221 8.35851 9.0846 8.06754 8.83601 7.82771C8.46607 7.4748 8.09614 7.12333 7.7151 6.7589Z"
          fill="#0072BB" />
        <path
          d="M22.3794 5.01937C24.2362 5.01937 26.093 5.01937 27.9498 5.02342C28.1449 5.02324 28.3383 5.05651 28.52 5.12149C28.6552 5.17861 28.7677 5.27274 28.8418 5.39086C28.916 5.50899 28.9483 5.64527 28.9341 5.78087C28.8912 6.06897 28.7352 6.29418 28.4201 6.3821C28.2549 6.42463 28.0837 6.44468 27.9121 6.44161C24.1985 6.44477 20.4852 6.44477 16.772 6.44161C16.6247 6.4426 16.4778 6.42784 16.3343 6.39765C16.1708 6.3648 16.0241 6.28267 15.9178 6.16444C15.8114 6.04622 15.7516 5.89875 15.7479 5.7457C15.7439 5.5986 15.7923 5.4543 15.8856 5.33444C15.9789 5.21458 16.1122 5.12563 16.2655 5.08091C16.4301 5.03805 16.6009 5.01799 16.772 5.0214C18.6414 5.01779 20.5105 5.01711 22.3794 5.01937Z"
          fill="#0072BB" />
        <path
          d="M22.3199 10.7207C20.463 10.7207 18.6062 10.7207 16.7501 10.7207C16.5786 10.7228 16.4079 10.6999 16.2442 10.6528C16.0926 10.6044 15.9622 10.5121 15.8728 10.3896C15.7834 10.2672 15.7399 10.1214 15.7488 9.97432C15.7558 9.82648 15.8153 9.6848 15.9183 9.57088C16.0212 9.45696 16.1619 9.37703 16.3189 9.34329C16.4742 9.31104 16.633 9.29533 16.7922 9.29647C20.4931 9.29647 24.1942 9.29647 27.8956 9.29647C28.0552 9.29509 28.2143 9.31127 28.3696 9.34464C28.5259 9.38047 28.6654 9.46152 28.7676 9.57578C28.8697 9.69004 28.9291 9.83145 28.9368 9.97906C28.9427 10.1267 28.897 10.2723 28.8062 10.3944C28.7155 10.5165 28.5845 10.6087 28.4325 10.6576C28.2686 10.7032 28.0979 10.7249 27.9267 10.722C26.058 10.7227 24.1886 10.7207 22.3199 10.7207Z"
          fill="#0072BB" />
        <path
          d="M22.3201 2.16664C20.4245 2.16664 18.5289 2.16664 16.6333 2.16664C16.3323 2.16664 16.0727 2.11405 15.8871 1.87329C15.8106 1.77164 15.7638 1.65313 15.7511 1.52941C15.7385 1.40569 15.7605 1.28102 15.8149 1.16766C15.8694 1.0543 15.9545 0.956153 16.0618 0.882875C16.1691 0.809596 16.295 0.76371 16.427 0.749724C16.5374 0.740843 16.6483 0.738529 16.7591 0.742802H27.9123C27.9988 0.742802 28.0853 0.742802 28.1711 0.742802C28.6149 0.769785 28.9551 1.10118 28.9366 1.4817C28.9181 1.86222 28.5957 2.15626 28.1556 2.15833C26.8014 2.16525 25.4472 2.16179 24.093 2.16179L22.3201 2.16664Z"
          fill="#0072BB" />
        <path
          d="M20.184 14.9968C18.9995 14.9968 17.8149 14.9968 16.6303 14.9968C16.1673 14.9968 15.881 14.8111 15.7784 14.4617C15.7464 14.362 15.7393 14.2568 15.7576 14.1542C15.7758 14.0515 15.8191 13.9541 15.884 13.8691C15.9489 13.7842 16.0338 13.7139 16.1324 13.6638C16.2309 13.6136 16.3404 13.5847 16.4527 13.5794C16.5516 13.5724 16.652 13.5745 16.7524 13.5745H23.6734C23.761 13.5745 23.8487 13.5745 23.9356 13.578C24.3574 13.6015 24.6407 13.8552 24.6586 14.2309C24.6774 14.6274 24.4234 14.924 24.003 14.9878C23.8916 14.9993 23.7794 15.0027 23.6674 14.9982L20.184 14.9968Z"
          fill="#0072BB" />
      </svg>
      <div class="flex flex-col">
        <div class="text-2xl font-bold">{{ odom }}<span class="text-base">km</span></div>
        <div class="mt-1 text-sm">Cumulative<br />Mileage</div>
      </div>
      <div class="flex flex-col">
        <div class="text-2xl font-bold">{{ power_used }}<span class="text-base">kWh</span></div>
        <div class="mt-1 text-sm">Cumulative<br />Power</div>
      </div>
    </div>
  </pannel>
</template>
<script>
export default {
  inject: ["device_online", "device_boot_status"],
  props: {
    md1_soc: {
      type: Number,
      default: 0,
    },
    md2_soc: {
      type: Number,
      default: 0,
    },
    md1_bms_charging_status: {
      type: Number,
      default: 0,
    },
    md2_bms_charging_status: {
      type: Number,
      default: 0,
    },

    md1_power_battery_current: {
      type: Number,
    },

    md2_power_battery_current: {
      type: Number,
    },

    power_used: {
      type: Number,
    },

    odom: {
      type: Number,
    },

    renewable_energy: {
      type: Number,
    },

    drive_brake_level: {
      type: Number,
    },
  },
  computed: {
    status_available() {
      return this.device_online && this.device_boot_status === 1;
    },
    md1_bms_charging_status_name() {
      if (this.md1_bms_charging_status === 0) {
        return "Not Charging";
      } else if (this.md1_bms_charging_status === 1) {
        return "Charging";
      } else if (this.md1_bms_charging_status === 2) {
        return "Charged";
      } else if (this.md1_bms_charging_status === 3) {
        return "Error";
      }
    },

    md2_bms_charging_status_name() {
      if (this.md2_bms_charging_status === 0) {
        return "Not Charging";
      } else if (this.md2_bms_charging_status === 1) {
        return "Charging";
      } else if (this.md2_bms_charging_status === 2) {
        return "Charged";
      } else if (this.md2_bms_charging_status === 3) {
        return "Error";
      }
    },
  },
};
</script>
